import { useId, type ComponentProps } from "react";

export default function CrossCircleIcon(props: ComponentProps<"svg">) {
  const id = useId();
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${id})`}>
        <path
          d="M12.0928 2C6.57855 2 2.09277 6.48578 2.09277 12C2.09277 17.5142 6.57855 22 12.0928 22C17.607 22 22.0928 17.5142 22.0928 12C22.0928 6.48578 17.607 2 12.0928 2Z"
          fill="#F44336"
        />
        <path
          d="M15.7755 14.504C16.1012 14.8299 16.1012 15.3565 15.7755 15.6824C15.613 15.8449 15.3996 15.9266 15.1862 15.9266C14.9728 15.9266 14.7595 15.8449 14.597 15.6824L12.0929 13.1782L9.58878 15.6824C9.42628 15.8449 9.21296 15.9266 8.99964 15.9266C8.78617 15.9266 8.57285 15.8449 8.41035 15.6824C8.08457 15.3565 8.08457 14.8299 8.41035 14.504L10.9146 11.9999L8.41035 9.49577C8.08457 9.16984 8.08457 8.64326 8.41035 8.31733C8.73627 7.99155 9.26286 7.99155 9.58878 8.31733L12.0929 10.8216L14.597 8.31733C14.923 7.99155 15.4495 7.99155 15.7755 8.31733C16.1012 8.64326 16.1012 9.16984 15.7755 9.49577L13.2712 11.9999L15.7755 14.504Z"
          fill="#FAFAFA"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(2.09277 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
